import "../../Styles/Landing/SodaqohL.css";
import RamadanPackage1 from "../../Assets/RamadanPackage1.png";
import RamadanPackage2 from "../../Assets/RamadanPackage2.png";

const SodaqohL = () => {
  return (
    <div className="sodaqohL">
      <div>
        <div>
          <h3>Provide Meals. Spread Hope.</h3>
          <h1>FEED MUSLIMS IN RAMADAN</h1>
          <p>
            This Ramadan, your generosity can make a difference. Join us in feeding families in need and bringing smiles
            to their faces.
          </p>
        </div>
        <div>
          <img src={RamadanPackage1} alt="Ramadan Package" />
          <img src={RamadanPackage2} alt="Ramadan Package" />
        </div>
        <a href="https://www.gofundme.com/f/feed-muslims-in-ramadan-project-fundraiser-p?attribution_id=sl:20307b90-04d4-476e-bbb9-586d25a1fd3a&utm_campaign=man_sharesheet_dash&utm_medium=customer&utm_source=whatsapp">
          Donate Now
        </a>
      </div>
    </div>
  );
};

export default SodaqohL;
